// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCiOutlinedSvg from "@fishx/icons-svg/es/asn/PCiOutlined";
import FishxIcon from '../components/FishxIcon';

var PCiOutlined = function PCiOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCiOutlinedSvg
  }));
};

PCiOutlined.displayName = 'PCiOutlined';
export default React.forwardRef(PCiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCiOutlined.js
// module id = 3286
// module chunks = 0